export default class AuthorizationError extends Error {}
